import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={230.701}
      height={173.442}
      viewBox="0 0 230.701 173.442"
      {...props}
    >
      <g data-name="Asset 3">
        <g data-name="Layer 2">
          <g data-name="Group 466">
            <path
              data-name="Path 9220"
              d="M222.319 124.721a15.028 15.028 0 01-.612-5.181c.505-7.759 6.743-13.689 8.305-21.185 1.517-7.31.591-15.59-5.212-20.852-8.022-7.269-20.634-6.475-26.347-16.742-5.116-9.2-4-20.316-9.574-29.516-5.252-8.649-13.659-14.558-22.5-19.108C153.576 5.51 138.709-.197 124.141.005c-16.55.238-28.358 11.48-39.429 22.4-9.756 9.605-26.938 8.739-21.934 33.574 4.464 22.116-6.066 20.473-15.7 28.642S30.424 102.49 34.253 113.52c4.216 12.172-21.615 19.153-26.22 34.92-3.129 10.7 13.284 11.6 24.456 11.6s106.741-.91 147.161.359c11.146.349 21.838.7 32.928-.657 4.706-.581 9.508-1.8 13.209-4.762 11.59-9.27-.572-20.27-3.468-30.259z"
              fill="#c3ecfe"
              opacity={0.35}
            />
          </g>
          <path
            data-name="Path 9221"
            d="M210.222 159.146a38.924 38.924 0 013.7-27.8l.288.162a38.574 38.574 0 00-3.665 27.565z"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9222"
            d="M212.885 133.72a7.228 7.228 0 011.946-4.63 1.456 1.456 0 011.077-.571.506.506 0 01.308.126.607.607 0 01.086.531 4.919 4.919 0 01-1.557 2.451c-.708.682-1.147 1.289-1.86 2.093"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9223"
            d="M211.607 136.955a7.249 7.249 0 013.624-3.478 1.471 1.471 0 011.213-.1.506.506 0 01.238.243.607.607 0 01-.136.505 4.857 4.857 0 01-2.4 1.633c-.92.344-1.562.728-2.527 1.183"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9224"
            d="M210.287 141.277a7.218 7.218 0 013.169-3.892 1.441 1.441 0 011.188-.248.445.445 0 01.263.212.591.591 0 01-.066.531 4.853 4.853 0 01-2.184 1.911c-.874.46-1.466.915-2.371 1.486"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9225"
            d="M209.59 145.631a7.208 7.208 0 013.175-3.892 1.436 1.436 0 011.188-.248.46.46 0 01.263.212.606.606 0 01-.066.531 4.838 4.838 0 01-2.189 1.911c-.869.46-1.461.915-2.371 1.486"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9226"
            d="M209.408 151.488a7.219 7.219 0 012.75-4.2 1.446 1.446 0 011.158-.369.45.45 0 01.283.182.591.591 0 010 .536 4.848 4.848 0 01-1.971 2.128c-.819.546-1.36 1.062-2.2 1.724"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9227"
            d="M209.685 155.744a7.734 7.734 0 012.4-4.266 1.613 1.613 0 011.082-.536.384.384 0 01.278.111.506.506 0 010 .505 5.449 5.449 0 01-1.769 2.265c-.748.637-1.238 1.2-2.022 1.941"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9228"
            d="M211.111 138.467a7.81 7.81 0 01-2.361-4.7 1.6 1.6 0 01.232-1.264.505.505 0 01.3-.167.591.591 0 01.46.288 5.333 5.333 0 01.92 2.917c.086 1.041.278 1.8.45 2.927"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9229"
            d="M210.207 141.843a7.82 7.82 0 01-3.417-4 1.613 1.613 0 01-.076-1.284.465.465 0 01.248-.232.6.6 0 01.505.167 5.373 5.373 0 011.592 2.618c.329.986.7 1.683 1.137 2.73"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9230"
            d="M209.57 146.337a7.82 7.82 0 01-4.145-3.235 1.618 1.618 0 01-.334-1.244.465.465 0 01.2-.278.6.6 0 01.541.061 5.353 5.353 0 012.078 2.244 28.058 28.058 0 001.663 2.452"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9231"
            d="M209.311 152.16a7.8 7.8 0 01-3.326-4.079 1.6 1.6 0 01-.051-1.279.47.47 0 01.253-.233.612.612 0 01.505.182 5.338 5.338 0 011.516 2.649c.308 1.011.662 1.7 1.077 2.76"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9232"
            d="M209.782 156.29a7.8 7.8 0 01-4.8-2.138 1.592 1.592 0 01-.622-1.127.505.505 0 01.121-.318.607.607 0 01.541-.071 5.368 5.368 0 012.558 1.678c.723.748 1.36 1.218 2.2 1.977"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9233"
            d="M229.623 159.445c0 .7-51.4 1.274-114.814 1.274S0 160.147 0 159.445s51.4-1.274 114.809-1.274 114.814.561 114.814 1.274z"
            fill="#afe1f2"
          />
          <path
            data-name="Line 226"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M124.54 11.47v10.944"
          />
          <path
            data-name="Line 227"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M101.737 15.489l3.741 10.287"
          />
          <path
            data-name="Line 228"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M81.683 27.065l7.037 8.386"
          />
          <path
            data-name="Line 229"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M66.802 44.802l9.478 5.475"
          />
          <path
            data-name="Line 230"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M58.88 66.559l10.782 1.901"
          />
          <path
            data-name="Line 231"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M58.88 89.711l10.782-1.901"
          />
          <path
            data-name="Line 232"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M66.802 111.467l9.478-5.469"
          />
          <path
            data-name="Line 233"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={3}
            d="M81.481 129.762l7.072-8.427"
          />
          <path
            data-name="Line 234"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={3}
            d="M101.63 141.388l3.761-10.332"
          />
          <path
            data-name="Line 235"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={3}
            d="M124.54 145.432v-11"
          />
          <path
            data-name="Line 236"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M147.338 140.782l-3.741-10.287"
          />
          <path
            data-name="Line 237"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M167.391 129.205l-7.037-8.386"
          />
          <path
            data-name="Line 238"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M182.272 111.467l-9.478-5.469"
          />
          <path
            data-name="Line 239"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M190.193 89.711l-10.782-1.901"
          />
          <path
            data-name="Line 240"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M190.193 66.559l-10.782 1.901"
          />
          <path
            data-name="Line 241"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M182.272 44.802l-9.478 5.475"
          />
          <path
            data-name="Line 242"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M167.391 27.065l-7.037 8.386"
          />
          <path
            data-name="Line 243"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M147.338 15.489l-3.741 10.287"
          />
          <path
            data-name="Path 9234"
            d="M133.52 159.151c22.353.3 46-.763 68.364-.46.753 0 3.195-.2-.88-2.831-3.453-2.224-14.356-.222-14.356-.222s2.528-1.011 2.528-2.33a3.588 3.588 0 00-2.2-3.033 8.169 8.169 0 00-3.872-.505 24.587 24.587 0 00-7.79 1.744 2.26 2.26 0 10-2.618-3.67c1.673-2.27 4.261-12.324-3.7-16.757-9.979-5.56-17.556-.981-19.174 2.361-.819-3.281-4.585-5.763-7.077-6.379-5.657-1.405-9.342-1.011-14.619 1.476-1.87.874-4.373 3.852-5.611 5.5-1.946 2.573-2.249 6-2.356 9.23q-.121 3.635-.03 7.264"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9235"
            d="M36.901 159.182c-10.454.142-21.514-.359-31.968-.217-.349 0-1.491-.1.415-1.324 1.613-1.011 6.713-.1 6.713-.1s-1.188-.475-1.183-1.092a1.668 1.668 0 011.011-1.41 3.836 3.836 0 011.81-.238 11.566 11.566 0 013.64.814 1.056 1.056 0 111.228-1.714c-.784-1.062-2-5.763 1.729-7.835 4.661-2.6 8.2-.46 8.962 1.1a4.874 4.874 0 013.3-2.982 9 9 0 016.839.692 10.2 10.2 0 012.624 2.568 7.5 7.5 0 011.1 4.317q.061 1.7 0 3.4"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9236"
            d="M66.994 57.268l-5.8 60.154a1.87 1.87 0 01-2.022 1.683l-9.706-.935a1.88 1.88 0 01-1.683-2.022l5.808-60.154a1.865 1.865 0 012.022-1.683l9.7.935a1.87 1.87 0 011.681 2.022z"
            fill="#fdefea"
          />
          <path
            data-name="Path 9237"
            d="M65.715 57.127l-1.011 10.66-10.9-1.051 1.011-10.656a.612.612 0 01.662-.541l9.731.955a.6.6 0 01.507.633z"
            fill="#f9a66e"
          />
          <path
            data-name="Rectangle 1215"
            fill="#ffb27e"
            d="M52.606 79.161l1.136-11.78 10.899 1.052-1.137 11.78z"
          />
          <path
            data-name="Rectangle 1216"
            fill="#a9d6d3"
            d="M54.267 67.357l.063-.632 10.95 1.095-.064.632z"
          />
          <path
            data-name="Rectangle 1217"
            fill="#fcbf95"
            d="M51.407 91.569l1.136-11.78 10.899 1.052-1.137 11.78z"
          />
          <path
            data-name="Rectangle 1218"
            fill="#a9d6d3"
            d="M52.545 79.804l.06-.63 10.899 1.054-.06.63z"
          />
          <path
            data-name="Rectangle 1219"
            fill="#ffd2b3"
            d="M50.209 103.983l1.136-11.78 10.899 1.052-1.137 11.78z"
          />
          <path
            data-name="Rectangle 1220"
            fill="#a9d6d3"
            d="M51.351 92.219l.06-.63 10.899 1.054-.06.63z"
          />
          <path
            data-name="Path 9238"
            d="M61.049 105.654l-1.122 11.629a.6.6 0 01-.652.541l-9.706-.935a.6.6 0 01-.541-.657l1.122-11.626z"
            fill="#ffe5d4"
          />
          <path
            data-name="Rectangle 1221"
            fill="#a9d6d3"
            d="M50.824 104.762l.063-.632 10.95 1.095-.064.632z"
          />
          <path
            data-name="Rectangle 1222"
            fill="#fdefea"
            d="M52.998 67.23l.063-.632 13.487 1.349-.063.632z"
          />
          <path
            data-name="Rectangle 1223"
            fill="#fdefea"
            d="M51.847 79.698l.063-.632 13.487 1.349-.063.632z"
          />
          <path
            data-name="Rectangle 1224"
            fill="#fdefea"
            d="M50.088 92.097l.06-.63 13.425 1.298-.06.63z"
          />
          <path
            data-name="Rectangle 1225"
            fill="#fdefea"
            d="M48.894 104.508l.06-.63 13.425 1.298-.06.63z"
          />
          <path
            data-name="Path 9239"
            d="M47.269 54.174l14.245 58.719a1.87 1.87 0 01-1.37 2.26l-9.478 2.3a1.875 1.875 0 01-2.26-1.38l-14.24-58.719a1.865 1.865 0 011.375-2.249l9.473-2.3a1.87 1.87 0 012.255 1.369z"
            fill="#fdefea"
          />
          <path
            data-name="Path 9240"
            d="M46.036 54.469l2.528 10.4-10.616 2.59-2.527-10.4a.607.607 0 01.445-.728l9.473-2.3a.6.6 0 01.7.445z"
            fill="#5eafbc"
          />
          <path
            data-name="Rectangle 1226"
            fill="#72c5ce"
            d="M38.066 68.082l10.64-2.58 2.79 11.5-10.641 2.58z"
          />
          <path
            data-name="Rectangle 1227"
            fill="#a9d6d3"
            d="M37.928 67.457l10.642-2.584.15.614-10.643 2.584z"
          />
          <path
            data-name="Rectangle 1228"
            fill="#93dee2"
            d="M41.012 80.191l10.642-2.584 2.793 11.503-10.642 2.584z"
          />
          <path
            data-name="Rectangle 1229"
            fill="#a9d6d3"
            d="M40.869 79.569l10.642-2.584.15.614-10.643 2.584z"
          />
          <path
            data-name="Rectangle 1230"
            fill="#abefef"
            d="M43.945 92.315l10.64-2.58 2.79 11.5-10.641 2.58z"
          />
          <path
            data-name="Rectangle 1231"
            fill="#a9d6d3"
            d="M43.807 91.693l10.642-2.584.15.614-10.643 2.584z"
          />
          <path
            data-name="Path 9241"
            d="M57.53 101.853l2.75 11.338a.6.6 0 01-.44.728l-9.473 2.3a.607.607 0 01-.728-.455l-2.75-11.343z"
            fill="#cff9f8"
          />
          <path
            data-name="Rectangle 1232"
            fill="#a9d6d3"
            d="M46.748 103.811l10.642-2.584.15.614-10.643 2.584z"
          />
          <path
            data-name="Rectangle 1233"
            fill="#fdefea"
            d="M36.695 67.756l13.11-3.183.149.614-13.11 3.183z"
          />
          <path
            data-name="Rectangle 1234"
            fill="#fdefea"
            d="M39.636 79.869l13.11-3.183.149.614-13.11 3.183z"
          />
          <path
            data-name="Rectangle 1235"
            fill="#fdefea"
            d="M42.574 91.992l13.11-3.183.149.614-13.11 3.183z"
          />
          <path
            data-name="Rectangle 1236"
            fill="#fdefea"
            d="M45.515 104.11l13.11-3.183.149.614-13.11 3.183z"
          />
          <path
            data-name="Path 9242"
            d="M32.14 60.801l29.571 52.693a1.87 1.87 0 01-.713 2.527l-8.5 4.8a1.865 1.865 0 01-2.527-.713l-29.6-52.7a1.875 1.875 0 01.718-2.527l8.5-4.772a1.875 1.875 0 012.551.692z"
            fill="#fdefea"
          />
          <path
            data-name="Path 9243"
            d="M31.033 61.423l5.242 9.352-9.549 5.358-5.242-9.352a.607.607 0 01.233-.819l8.5-4.792a.6.6 0 01.814.253z"
            fill="#ffcd69"
          />
          <path
            data-name="Rectangle 1237"
            fill="#ffd385"
            d="M27.033 76.677l9.548-5.358 5.792 10.32-9.549 5.358z"
          />
          <path
            data-name="Rectangle 1238"
            fill="#a9d6d3"
            d="M26.728 76.113l9.547-5.36.31.551-9.548 5.36z"
          />
          <path
            data-name="Rectangle 1239"
            fill="#ffdca4"
            d="M33.136 87.551l9.548-5.358 5.792 10.32-9.549 5.358z"
          />
          <path
            data-name="Rectangle 1240"
            fill="#a9d6d3"
            d="M32.83 86.997l9.548-5.358.31.55-9.549 5.36z"
          />
          <path
            data-name="Rectangle 1241"
            fill="#ffe8c7"
            d="M39.236 98.429l9.548-5.358 5.792 10.32-9.549 5.358z"
          />
          <path
            data-name="Rectangle 1242"
            fill="#a9d6d3"
            d="M38.937 97.864l9.547-5.36.31.551-9.548 5.36z"
          />
          <path
            data-name="Path 9244"
            d="M54.892 103.941l5.712 10.176a.6.6 0 01-.222.819l-8.5 4.772a.607.607 0 01-.824-.233l-5.715-10.176z"
            fill="#fff3e3"
          />
          <path
            data-name="Rectangle 1243"
            fill="#a9d6d3"
            d="M45.034 108.742l9.548-5.358.31.55-9.549 5.36z"
          />
          <path
            data-name="Rectangle 1244"
            fill="#fdefea"
            d="M25.613 76.744l11.762-6.6.309.55-11.762 6.601z"
          />
          <path
            data-name="Rectangle 1245"
            fill="#fdefea"
            d="M31.723 87.616l11.76-6.602.31.55-11.76 6.603z"
          />
          <path
            data-name="Rectangle 1246"
            fill="#fdefea"
            d="M37.825 98.494l11.762-6.6.309.55-11.762 6.601z"
          />
          <path
            data-name="Rectangle 1247"
            fill="#fdefea"
            d="M43.923 109.368l11.762-6.6.309.55-11.762 6.601z"
          />
          <path
            data-name="Path 9245"
            d="M51.197 153.676a83.489 83.489 0 01-35.021-48.942l.682-.172a82.776 82.776 0 0034.718 48.528z"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9246"
            d="M18.052 109.967a15.5 15.5 0 01-3.741-10.11 3.1 3.1 0 01.834-2.472 1.036 1.036 0 01.682-.253 1.3 1.3 0 01.9.7 10.447 10.447 0 011.158 6.122c-.1 2.108.1 3.705.162 6.005"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9247"
            d="M20.801 116.906a15.483 15.483 0 01.571-10.747 3.1 3.1 0 011.749-1.931 1.011 1.011 0 01.723.03 1.314 1.314 0 01.556 1.011 10.361 10.361 0 01-1.37 6.066c-.93 1.88-1.375 3.437-2.229 5.56"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9248"
            d="M25.096 125.596a15.468 15.468 0 01-.746-10.749 3.066 3.066 0 011.516-2.133 1.011 1.011 0 01.723-.056 1.3 1.3 0 01.672.935 11.009 11.009 0 01-.637 6.218c-.672 2.022-.94 3.579-1.516 5.808"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9249"
            d="M30.381 133.452a15.453 15.453 0 01-.752-10.743 3.059 3.059 0 011.516-2.133 1.011 1.011 0 01.723-.056 1.269 1.269 0 01.672.93 10.47 10.47 0 01-.612 6.2c-.687 2-.945 3.579-1.516 5.8"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9250"
            d="M38.681 142.895a15.483 15.483 0 01-1.86-10.614 3.2 3.2 0 011.269-2.28 1.011 1.011 0 01.713-.126 1.294 1.294 0 01.768.854 10.479 10.479 0 01.03 6.233c-.475 2.057-.566 3.66-.92 5.935"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9251"
            d="M45.368 149.127a16.5 16.5 0 01-2.527-10.2 3.5 3.5 0 01.9-2.431.829.829 0 01.6-.227c.344.035.576.389.733.733a11.6 11.6 0 01.556 6.142c-.243 2.1-.136 3.71-.263 5.985"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9252"
            d="M22.242 120a16.742 16.742 0 01-10.615-3.892 3.435 3.435 0 01-1.491-2.315 1.011 1.011 0 01.217-.7 1.289 1.289 0 011.147-.233 11.582 11.582 0 015.717 3.23c1.673 1.5 3.084 2.411 5 3.913"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9253"
            d="M25.783 126.622a16.783 16.783 0 01-11.222-1.254 3.6 3.6 0 01-2.022-1.9 1.011 1.011 0 01.045-.733 1.294 1.294 0 011.056-.505 11.505 11.505 0 016.324 1.769c1.961 1.062 3.594 1.618 5.818 2.618"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9254"
            d="M31.376 134.589a16.767 16.767 0 01-11.242 1.011 3.4 3.4 0 01-2.34-1.451 1.011 1.011 0 01-.1-.728c.116-.379.541-.576.935-.7a11.573 11.573 0 016.571.465c2.158.647 3.822.864 6.2 1.4"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9255"
            d="M39.48 144.072a16.757 16.757 0 01-11.172-1.516 3.429 3.429 0 01-1.956-1.936 1.011 1.011 0 01.061-.733 1.279 1.279 0 011.067-.475 11.514 11.514 0 016.283 1.911c1.941 1.107 3.538 1.688 5.732 2.735"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9256"
            d="M46.339 149.84a16.792 16.792 0 01-10.666 3.7 3.394 3.394 0 01-2.618-.854.976.976 0 01-.273-.677c0-.4.384-.693.738-.9a11.514 11.514 0 016.47-1.127c2.229.111 3.918-.081 6.349-.136"
            fill="#bae9f4"
          />
          <path
            data-name="Line 244"
            fill="none"
            stroke="#3e89cc"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={3}
            d="M179.841 119.626l-6.526 39.484"
          />
          <path
            data-name="Line 245"
            fill="none"
            stroke="#3e89cc"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={3}
            d="M196.037 119.626l6.526 39.484"
          />
          <path
            data-name="Rectangle 1248"
            fill="#3e89cc"
            d="M156.664 78.443h64.668v47.133h-64.668z"
          />
          <path
            data-name="Rectangle 1249"
            fill="#eefbff"
            d="M159.191 80.288h59.613v43.453h-59.613z"
          />
          <path
            data-name="Line 246"
            fill="none"
            stroke="#3e89cc"
            strokeMiterlimit={10}
            strokeWidth={3}
            d="M176.176 141.792h23.526"
          />
          <text
            transform="rotate(.573 -10240.824 18135.978)"
            fill="#3e89cc"
            fontSize={8}
            fontFamily="SegoeUI, Segoe UI"
          >
            <tspan x={0} y={0}>
              {"idea"}
            </tspan>
          </text>
          <path
            data-name="Path 9257"
            d="M71.685 159.151H34.571l-6.233-67.115a1.37 1.37 0 011.2-1.6h47.181a1.37 1.37 0 011.2 1.6z"
            fill="#81d9fc"
          />
          <path
            data-name="Path 9258"
            d="M108.373 145.74v13.5h-67.62a2.841 2.841 0 01-2.841-2.824v-9.756a2.765 2.765 0 01.152-.92z"
            fill="#2775af"
          />
          <path
            data-name="Path 9259"
            d="M108.373 145.74v11.712H38.112a2.821 2.821 0 01-.2-1.036v-9.756a2.765 2.765 0 01.152-.92z"
            fill="#fff"
          />
          <path
            data-name="Rectangle 1250"
            fill="#c3ecfe"
            d="M37.912 147.095H115.4v.743H37.912z"
          />
          <path
            data-name="Rectangle 1251"
            fill="#c3ecfe"
            d="M37.912 148.768H115.4v.743H37.912z"
          />
          <path
            data-name="Rectangle 1252"
            fill="#c3ecfe"
            d="M37.912 150.441H115.4v.743H37.912z"
          />
          <path
            data-name="Rectangle 1253"
            fill="#c3ecfe"
            d="M37.912 152.115H115.4v.743H37.912z"
          />
          <path
            data-name="Rectangle 1254"
            fill="#c3ecfe"
            d="M37.912 153.788H115.4v.748H37.912z"
          />
          <path
            data-name="Rectangle 1255"
            fill="#c3ecfe"
            d="M37.912 155.461H115.4v.748H37.912z"
          />
          <path
            data-name="Path 9260"
            d="M90.383 145.205h-2.937v8.326l2.937-2.416 2.937 2.416v-7.112z"
            fill="#595959"
            opacity={0.2}
          />
          <path
            data-name="Path 9261"
            d="M90.808 144.527l-2.942 1.213v7.117l2.942-2.416 2.937 2.416v-7.117z"
            fill="#ff8736"
          />
          <path
            data-name="Path 9262"
            d="M108.374 143.814v1.926h-70.31a2.831 2.831 0 012.689-1.926z"
            fill="#2775af"
          />
          <path
            data-name="Path 9263"
            d="M113.262 130.424v13.5h-67.62a2.821 2.821 0 01-2.639-1.8 2.751 2.751 0 01-.2-1.041v-9.759a2.76 2.76 0 01.167-.9z"
            fill="#3e89cc"
          />
          <path
            data-name="Path 9264"
            d="M113.261 130.424v11.712H42.997a2.75 2.75 0 01-.2-1.041v-9.756a2.759 2.759 0 01.172-.915z"
            fill="#fff"
          />
          <path
            data-name="Rectangle 1256"
            fill="#c3ecfe"
            d="M42.801 131.763h77.488v.743H42.801z"
          />
          <path
            data-name="Rectangle 1257"
            fill="#c3ecfe"
            d="M42.801 133.437h77.488v.743H42.801z"
          />
          <path
            data-name="Rectangle 1258"
            fill="#c3ecfe"
            d="M42.801 135.11h77.488v.743H42.801z"
          />
          <path
            data-name="Rectangle 1259"
            fill="#c3ecfe"
            d="M42.801 136.778h77.488v.748H42.801z"
          />
          <path
            data-name="Rectangle 1260"
            fill="#c3ecfe"
            d="M42.801 138.451h77.488v.753H42.801z"
          />
          <path
            data-name="Rectangle 1261"
            fill="#c3ecfe"
            d="M42.801 140.124h77.488v.753H42.801z"
          />
          <path
            data-name="Path 9265"
            d="M53.3 130.014l-2.937-.374v8.7l2.937-2.416 2.937 2.416v-7.117z"
            fill="#595959"
            opacity={0.2}
          />
          <path
            data-name="Path 9266"
            d="M53.952 129.195l-2.937 1.213v7.117l2.937-2.416 2.937 2.416v-7.117z"
            fill="#ffc840"
          />
          <path
            data-name="Path 9267"
            d="M113.262 128.478v1.95H42.967a2.836 2.836 0 012.684-1.931z"
            fill="#3e89cc"
          />
          <path
            data-name="Path 9268"
            d="M213.093 102.439a.364.364 0 00.329-.359.374.374 0 00-.743 0 .364.364 0 00.273.349c-.253 1.9-2.527 3.382-5.348 3.427h-.258c-2.8-.046-5.1-1.517-5.348-3.427a.359.359 0 00.273-.349.369.369 0 00-.738 0 .364.364 0 00.324.359c.217 1.643 1.9 2.988 4.115 3.417h-3.9a.364.364 0 00-.354-.293.369.369 0 100 .738.364.364 0 00.354-.293h10.3a.364.364 0 00.354.293.369.369 0 100-.738.364.364 0 00-.354.293h-3.387c2.217-.43 3.89-1.774 4.108-3.417z"
            fill="#3e89cc"
          />
          <path
            data-name="Path 9269"
            d="M210.424 101.929l-2.927 4-.212-5.56a1.112 1.112 0 10-.791-.32 1.107 1.107 0 00.791.32l-.051 5.56s-1.987-2.806-3.033-4.13a43.715 43.715 0 001.168-5.98c.04-.238.061-.379.061-.379h3.847a1.261 1.261 0 00.04.379c.252 2.066 1.107 6.11 1.107 6.11z"
            fill="#71606e"
          />
          <path
            data-name="Path 9270"
            d="M209.332 95.822h-3.973c.04-.238.061-.379.061-.379h3.857c.025.1.032.248.055.379z"
            fill="#71606e"
            opacity={0.2}
          />
          <path
            data-name="Path 9271"
            d="M210.039 94.028v1.163a.394.394 0 01-.394.4h-4.676a.4.4 0 01-.394-.369v-1.193a.394.394 0 01.394-.394h4.676a.394.394 0 01.394.393z"
            fill="#ff8736"
          />
          <path
            data-name="Path 9272"
            d="M210.039 94.028v1.163a.394.394 0 01-.394.4h-4.676a.4.4 0 01-.394-.369c3.857.227 3.761-1.117 3.614-1.587h1.456a.394.394 0 01.394.393z"
            fill="#71606e"
            opacity={0.2}
          />
          <path
            data-name="Path 9273"
            d="M142.97 140.336v3.23a3.624 3.624 0 01-3.619 3.619h-32.019a3.624 3.624 0 01-3.619-3.6v-3.22a3.619 3.619 0 013.619-3.619h32.018a3.619 3.619 0 013.619 3.594z"
            fill="#71606e"
          />
          <path
            data-name="Path 9274"
            d="M142.97 152.554v3.2a3.624 3.624 0 01-3.619 3.624h-32.019a3.63 3.63 0 01-3.619-3.624v-3.2a3.624 3.624 0 013.619-3.624h32.018a3.624 3.624 0 013.619 3.624z"
            fill="#71606e"
          />
          <path
            data-name="Path 9275"
            d="M171.278 78.499a46.7 46.7 0 01-10.317 29.349 45.548 45.548 0 01-4.989 5.318 46.563 46.563 0 01-7.633 5.672 21.858 21.858 0 00-10.717 17.091c0 .258-.03.506-.04.789h-28.48a23.6 23.6 0 00-3.746-11.854 25.384 25.384 0 00-1.709-2.371 23.8 23.8 0 00-5.055-4.762A46.927 46.927 0 01123.7 31.594a47.559 47.559 0 015.323.222 46.925 46.925 0 0142.255 46.683z"
            fill="#ffc840"
          />
          <path
            data-name="Rectangle 1262"
            fill="#443a43"
            d="M106.867 147.085h32.943v1.85h-32.943z"
          />
          <path
            data-name="Path 9276"
            d="M171.278 78.501a46.9 46.9 0 01-22.936 40.337 22.626 22.626 0 00-10.873 17.794q-14.124.222-28.257 0a24.315 24.315 0 00-3.756-11.48c12.809-1.633 25.689-5.3 35.992-13.082 20.064-15.169 21.464-42.013 8.321-62.349a49.362 49.362 0 00-20.761-17.92 46.925 46.925 0 0142.27 46.7z"
            fill="#ffb839"
            opacity={0.2}
          />
          <path
            data-name="Path 9277"
            d="M142.97 140.336v3.23a3.624 3.624 0 01-3.619 3.619h-32.019a3.624 3.624 0 01-3.619-3.6c24.335 2.457 26.751-4.767 26.953-6.839h8.684a3.619 3.619 0 013.619 3.594z"
            fill="#71606e"
            opacity={0.2}
          />
          <path
            data-name="Path 9278"
            d="M142.97 152.554v3.2a3.624 3.624 0 01-3.619 3.624h-32.019a3.624 3.624 0 01-3.538-2.917c29.556 2.527 24.36-7.532 24.36-7.532h11.21a3.624 3.624 0 013.606 3.625z"
            fill="#71606e"
            opacity={0.2}
          />
          <g
            data-name="Group 467"
            opacity={0.5}
            fill="none"
            stroke="#ffe1b0"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={16}
          >
            <path
              data-name="Path 9279"
              d="M92.855 56.788c-4.044 6.314-7.077 15.67-6.026 29.4"
            />
            <path
              data-name="Path 9280"
              d="M107.539 44.651a25.123 25.123 0 00-7.264 4.044"
            />
          </g>
          <path
            data-name="Path 9281"
            d="M67.671 93.619a1.2 1.2 0 01.713.885 1.178 1.178 0 01-.379 1.067.647.647 0 01.506.738 1.623 1.623 0 01-.506.869 1.476 1.476 0 01-1.011.576 1.127 1.127 0 01-.758-.329 1.4 1.4 0 01-.349-.506 2.324 2.324 0 01-.126-.672c-.071-.8-.137-1.607-.207-2.411a.591.591 0 01.1-.465"
            fill="#0b0b3a"
          />
          <path
            data-name="Path 9282"
            d="M60.741 98.926c-.051 1.046 0 2.866-.278 3.134a8.184 8.184 0 01-2.4.258s4.59 4.332 4.9 4.095 4.393-3.569 3.473-3.741-1.815-.131-1.789-.607.056-.95.081-1.426"
            fill="#ed9c80"
          />
          <path
            data-name="Path 9283"
            d="M56.808 122.235s6.733.763 8.285.794 1.471-.773 1.471-.773a62.007 62.007 0 01.687-7.077c.3-1.274.435-1.744.693-2.952.581-2.689.556-3.2 1.168-6.516l-4.019-3.235a2.123 2.123 0 01-2.1 1.259 3.067 3.067 0 01-2.957-1.552l-5.485 3.645-.506 8.861 2.068 6.769"
            fill="#0094bc"
          />
          <path
            data-name="Path 9284"
            d="M60.66 97.981a11.875 11.875 0 00.475 1.547 1.754 1.754 0 001.86 1.279l2.062.051a2.371 2.371 0 001.607-.339 2.319 2.319 0 00.505-1.516c.121-.647.217-1.3.293-1.961a29.247 29.247 0 00.182-3.877 3.032 3.032 0 00-.045-.531.354.354 0 00-.091-.2.415.415 0 00-.248-.1 20.928 20.928 0 00-3.9-.248 4.4 4.4 0 00-2.624.7 4.934 4.934 0 00-1.4 2.361c-.051.136-.086.324.035.409"
            fill="#ed9c80"
          />
          <path
            data-name="Path 9285"
            d="M75.4 144.922a14.427 14.427 0 01-.389 1.739c-.172.445-1.623.035-1.719-.253a13.265 13.265 0 01.455-2.391"
            fill="#ed9c80"
          />
          <path
            data-name="Path 9286"
            d="M72.792 146.777c-.126.475-.283 1.39-.283 1.39l1.451.632.238-.222a2.709 2.709 0 00.8.642 6.172 6.172 0 001.405.389 3.413 3.413 0 002.275-.278c.313-.733-1.365-.93-1.7-1.011a2.224 2.224 0 01-1.592-1.6c-.076-.384 0-.45-.2-.44a.505.505 0 00-.359.172.925.925 0 01-1.011.238 1.052 1.052 0 01-.506-.43.637.637 0 00-.518.518z"
            fill="#3a3a3a"
          />
          <path
            data-name="Path 9287"
            d="M68.985 128.008a24.043 24.043 0 007.31.475 21.268 21.268 0 00-1.3 3.089 92.164 92.164 0 00-1.582 13.568s.475.91 1.992.217c2.275-5.616 6.243-16.985 6.2-19.457-.045-3.139-7.886-3.9-13.648-4.671"
            fill="#243a6c"
          />
          <g data-name="Group 468">
            <path
              data-name="Path 9288"
              d="M58.972 121.719c-1.8 1.319 10.014 6.288 10.014 6.288a19.547 19.547 0 003.877.369 2.952 2.952 0 00.288-.733c.066-.344.03-.7.091-1.046a2.431 2.431 0 011.183-1.592 5.348 5.348 0 011.931-.622 26.06 26.06 0 014.388-.081c-3.538-2.618-10.464-2.022-13.851-2.239-.647 1.066-7.664-.536-7.921-.344z"
              fill="#40536d"
              opacity={0.5}
            />
          </g>
          <g data-name="Group 469">
            <path
              data-name="Path 9289"
              d="M74.394 146.12c-.051.273-.121.617-.192.895h.066c.217 0 .121.056.192.44a2.244 2.244 0 001.592 1.6c.334.086 2.022.283 1.7 1.011a3.421 3.421 0 01-2.275.278 6.1 6.1 0 01-1.405-.389 2.709 2.709 0 01-.8-.642l-.243.222-1.451-.632s.162-.915.288-1.39a.632.632 0 01.505-.506 7.3 7.3 0 01.177-1.041.768.768 0 01-.056-.081 96.653 96.653 0 011.582-13.563 8.059 8.059 0 01.738-1.9 9.536 9.536 0 00.551-1.193 17.787 17.787 0 01-3.377.061 10.919 10.919 0 01-.04 1.132c-.227 5.055-1.067 12.6-.945 18.582a1.264 1.264 0 01-.278.162 7.353 7.353 0 01-.035.88h.066c.207-.051.126.035.268.4a2.219 2.219 0 001.845 1.294c.344.03 2.022-.066 1.85.708a3.43 3.43 0 01-2.194.667 6.065 6.065 0 01-1.451-.137 2.683 2.683 0 01-.9-.505l-.2.263-1.516-.374s0-.925.04-1.42a.627.627 0 01.394-.591 8.089 8.089 0 010-1.127 4.628 4.628 0 01-.435-.162c-.379-4.115-2.659-13.406-1.517-18.628a7.983 7.983 0 01.324-1.142c-4.266.566-7.941 1.1-11.819-.187a1.956 1.956 0 01-.92-.6h25.922a23.765 23.765 0 01-.505 1.931c-1.259 4.549-3.786 11.626-5.434 15.67z"
              fill="#595959"
              opacity={0.2}
            />
          </g>
          <path
            data-name="Path 9290"
            d="M71.654 147.907a14.581 14.581 0 01-.081 1.779c-.1.465-1.6.313-1.739.051a13.5 13.5 0 01.035-2.431"
            fill="#ed9c80"
          />
          <path
            data-name="Path 9291"
            d="M69.399 150.189c-.04.505-.04 1.42-.04 1.42l1.516.369.2-.263a2.7 2.7 0 00.9.505 6.111 6.111 0 001.451.136 3.4 3.4 0 002.194-.667c.182-.773-1.517-.677-1.85-.708a2.224 2.224 0 01-1.845-1.294c-.142-.364-.056-.45-.268-.4a.505.505 0 00-.329.233.92.92 0 01-.971.415 1.107 1.107 0 01-.581-.334.632.632 0 00-.377.588z"
            fill="#3a3a3a"
          />
          <path
            data-name="Path 9292"
            d="M55.029 121.456c-.607 1.41-1.011 3.953-.394 5.055.505.955.784 1.547 1.693 1.85 3.872 1.284 7.547.753 11.813.187-1.8 4.883.814 15.337 1.218 19.77a2.466 2.466 0 002.568-.046c-.182-9.023 1.825-21.625.612-23.758-.743-1.309-9.574-3.033-9.751-3.033"
            fill="#243a6c"
          />
          <path
            data-name="Path 9293"
            d="M61.797 96.399c-.076-.313-.556-.334-.773-.1a1.35 1.35 0 00-.258.9 2.133 2.133 0 00.389 1.132c.207.334.505.531.8.253a1.011 1.011 0 01-.844 1.072.935.935 0 01-.925-.637c-1.749.642-2.3-1.891-2.406-3.154a5.212 5.212 0 01.789-3.033 2.148 2.148 0 011.264-.95 2.022 2.022 0 011.082-1.516 5.277 5.277 0 011.693-.591 2.1 2.1 0 011.648.6c.743-.425 1.405 0 1.992.056s1.249.617 1.011 1.153a1.415 1.415 0 011.648 1.7 1.516 1.516 0 01-2.356.662 1.774 1.774 0 01-1.623.95 3.447 3.447 0 01-1.85-.642 1.4 1.4 0 01.066 1.208c-.182.4-.329.7-.92.576 0 0 .051.915-.157.829s-.27-.468-.27-.468z"
            fill="#0b0b3a"
          />
          <path
            data-name="Path 9294"
            d="M73.601 119.172c-2.351-3.392-3.609-6.066-5.657-9.645l-2.851-7.077 1.147.071a8.629 8.629 0 012.376.45 4.944 4.944 0 012.75 2.209c.475.95.763 1.987 1.163 2.967.45 1.1.925 2.179 1.405 3.266.95 2.148 1.921 4.3 2.725 6.506"
            fill="#0094bc"
          />
          <path
            data-name="Path 9295"
            d="M68.338 110.224l.384-2.295 2.816 6.172-.93.227z"
            fill="#070707"
            opacity={0.2}
          />
          <path
            data-name="Path 9296"
            d="M54.523 105.695a70.016 70.016 0 00.3 13.219 29.159 29.159 0 00.576 3.63c.035.152.293.126.278-.035-.1-1.082-.288-2.153-.42-3.23s-.248-2.2-.334-3.306q-.258-3.26-.227-6.526c0-1.249.045-2.5.111-3.751a.144.144 0 00-.284-.001z"
          />
          <path
            data-name="Rectangle 1263"
            fill="#aabde2"
            d="M58.345 122.083h21.757v.784H58.345z"
          />
          <path
            data-name="Path 9297"
            d="M83.978 122.841H66.564l3.124-10.176a1.334 1.334 0 011.279-.945h15.251a.869.869 0 01.829 1.122z"
            fill="#aabde2"
          />
          <path
            data-name="Path 9298"
            d="M84.196 122.841H67.044l3.124-10.176a1.335 1.335 0 011.279-.945h15.251a.864.864 0 01.829 1.122l-2.993 9.751a.354.354 0 01-.338.248z"
            fill="#e1e8f9"
          />
          <g data-name="Group 470">
            <path
              data-name="Path 9299"
              d="M57.071 107.535a90.716 90.716 0 011.516 11.626c3.362.248 4.307 1.516 7.385 2.912 0 0 2.437-.4 2.689.505.152.531-2.846.95-2.846.95a75.35 75.35 0 01-10.287-1.461c-.511-.136-2.6-10.464-2.664-15.67a3.22 3.22 0 01.506-2.113 2.74 2.74 0 01.93-.687 12.951 12.951 0 015.748-1.456"
              fill="#070707"
              opacity={0.2}
            />
          </g>
          <path
            data-name="Path 9300"
            d="M65.555 122.71a1.8 1.8 0 011.516-.475 10.618 10.618 0 011.168.1c.182 0 .394.066.409.263s-.88 0-1.355.136a23.387 23.387 0 002.79.076.85.85 0 01.318.035.268.268 0 01.182.243.334.334 0 01-.126.212 1.921 1.921 0 01-.96.389 7.421 7.421 0 01-4.236-.374"
            fill="#ed9c80"
          />
          <path
            data-name="Path 9301"
            d="M57.162 107.539c.076 4.332.7 8.27.612 12.607a20.95 20.95 0 018.154 2.27 1.638 1.638 0 01-.1 1.127c-.238.086-10.064-.329-10.873-1.072-.723-.667-2.022-10.853-2.078-16.05a3.22 3.22 0 01.506-2.113 2.74 2.74 0 01.93-.687 12.951 12.951 0 015.748-1.456"
            fill="#0094bc"
          />
          <path
            data-name="Path 9302"
            d="M67.069 96.191s1.011 1.82.875 2.052-1.375 0-1.375 0"
            fill="#ed9c80"
          />
          <path
            data-name="Path 9303"
            d="M76.295 117.038a1.815 1.815 0 10.53-1.286 1.815 1.815 0 00-.53 1.286z"
            fill="#fff"
          />
          <path
            data-name="Path 9304"
            d="M166.334 99.482a47.3 47.3 0 002.644-6.42 1.962 1.962 0 01-.647-.157c-2.75-1.592-2.5 1.238-2.108 2.305.131.364.43.824.506 1.011a9.537 9.537 0 01-.066 1.218.652.652 0 00.293.505 6.389 6.389 0 01-.46 1.173.809.809 0 00-.162.364zm.92-2.6a.318.318 0 000-.051v.076a.205.205 0 01.001-.028zm-6.981 11.121c-1.082.268-1.451 0-1.451 0a22.141 22.141 0 00-2.123-.809c-.566-.2-1.294-.506-2.062-.814l-11.151-11.257-.935-.9a4.68 4.68 0 000-.819 3.416 3.416 0 00-2.29-3.255c-1.81-.556-3.164.147-4.458-.344l-1.724-1.516-.066-.1v.051c.627 2.9.505 9.069 5.874 8.755l.854.864 5.56 5.6a8.8 8.8 0 002.31 2.33l7.34 7.411a45.548 45.548 0 004.989-5.318l-.627.162z"
            opacity={0.2}
          />
          <path
            data-name="Path 9305"
            d="M157.63 172.29c0 .637 7.143 1.152 15.954 1.152s15.948-.505 15.948-1.152-7.143-1.153-15.948-1.153-15.954.516-15.954 1.153z"
            fill="#afe1f2"
          />
          <path
            data-name="Path 9306"
            d="M170.859 106.357a1.44 1.44 0 01-.465.8 1.673 1.673 0 01-.95.435c-.94.1-2.391.3-3.928.505a49.8 49.8 0 01-6.278.607 5.93 5.93 0 01-2-.278h-.061c-.167-.147-.172-.546-.121-.94s.157-.864.167-.981a1.936 1.936 0 011.557-1.678 1.753 1.753 0 01.258-.051l.172-.056a45.212 45.212 0 016.607-1.2 5.561 5.561 0 012.437.126 4.97 4.97 0 011.517.7 1.953 1.953 0 011.088 2.011z"
            fill="#35aad3"
          />
          <path
            data-name="Path 9307"
            d="M159.55 107.459a1.725 1.725 0 01-.233.44 2.068 2.068 0 01-.142.152 2.143 2.143 0 01-1.709.445l-.212-.071-.071-.03a47.615 47.615 0 01-6.748-4.549c-1.279-.986-2.2-1.724-2.2-1.724l.192-.293.758-1.112s4.757 2.249 7.006 3.033a14.66 14.66 0 012.618 1.067 2.893 2.893 0 01.243.162 2.7 2.7 0 01.498 2.48z"
            fill="#35aad3"
          />
          <path
            data-name="Path 9308"
            d="M165.525 108.096a49.8 49.8 0 01-6.278.607 5.93 5.93 0 01-2-.278h-.061a47.612 47.612 0 01-6.748-4.549c.308.187 4.362 2.527 6.627 3.619a7.514 7.514 0 001.279.506 4.622 4.622 0 00.839.076h.126a6.066 6.066 0 005.09-2.927 11.077 11.077 0 011.011-1.37s.069 2.521.115 4.316z"
            fill="#2496b5"
          />
          <path
            data-name="Path 9309"
            d="M158.287 104.532s.369.268 1.451 0-.056 1.057-.056 1.057l-1.7-.106-.142-.44z"
            fill="#35aad3"
          />
          <path
            data-name="Path 9310"
            d="M175.519 116.945a6.4 6.4 0 00-.288 3.72c.546 2.467-.076 2.629-.076 2.629a31.86 31.86 0 01-6.127 2.993c-1.992.617-3.69.506-3.64-1.688v-.415c.091-4.944-.935-5.2-1.193-10.732-.263-5.682-.2-9.043 1.613-9.958a12.029 12.029 0 018.593-.768c2.9.682 3.862 1.451 3.837 3.6a17.458 17.458 0 01-.313 2.644 47.866 47.866 0 01-2.406 7.975z"
            fill="#35aad3"
          />
          <path
            data-name="Path 9311"
            d="M175.519 116.942a6.4 6.4 0 00-.288 3.72c.546 2.467-.076 2.629-.076 2.629a31.86 31.86 0 01-6.127 2.993l-2.593-.248-1.041-.819v-1.036a19.34 19.34 0 003.923-.1 16.444 16.444 0 003.847-.965 1.517 1.517 0 00.945-1.663 21.515 21.515 0 01-.359-3.453 18.061 18.061 0 01.925-4.251 8.624 8.624 0 00.344-3.149 28.344 28.344 0 010-3.584l2.057-1.117 1.147.43a17.455 17.455 0 01-.313 2.644 47.86 47.86 0 01-2.391 7.969z"
            fill="#2496b5"
          />
          <path
            data-name="Path 9312"
            d="M166.218 96.707c.379.152.222 1.441.293 1.855s.369 2.022 1.218 2.275 1.375.313 1.375.455a5.129 5.129 0 01-.04.652 1.531 1.531 0 01-.025.349c-.025.1 0 .061 0 .081a.163.163 0 000 .066 1.67 1.67 0 00.076.6l.556.369a.44.44 0 00.288.152l.586.046a.349.349 0 00.126 0l.329-.1c.045-.2.076-.349.081-.354s1.041-.687 1.638-1.082a13.773 13.773 0 01.131-1.516c.035-.152.475-1.011.93-2.022l.111-.258c.1-.227.2-.46.293-.693a.293.293 0 00.04-.091 7.158 7.158 0 00.586-2.179c0-1.486-.051-3.033-.971-3.806s-6.678-3.493-6.87.986a.448.448 0 010 .081 20.732 20.732 0 01-1.011 3.033.713.713 0 00.258 1.1z"
            fill="#ed9c80"
          />
          <path
            data-name="Path 9313"
            d="M169.099 103.041l.056.278a.415.415 0 00.415.334l.986-.04a.258.258 0 00.1 0l.329-.1c.046-.2.076-.349.081-.354s1.041-.687 1.638-1.082a13.759 13.759 0 01.131-1.516c.035-.152.475-1.011.93-2.022l.111-.258c.1-.227.2-.46.293-.693a.414.414 0 00.03-.192l-.04-.445a.4.4 0 00-.359-.369c-.505-.056-1.36-.152-1.405-.147a6.427 6.427 0 00-.6 1.087c0 .046.248.794.313 1.011a.725.725 0 010 .1c0 .227.04 1.158 0 2.022a1.709 1.709 0 01-.88 1.451l-.076.04a14.616 14.616 0 01-2.057.89z"
            fill="#f29d77"
          />
          <path
            data-name="Path 9314"
            d="M165.966 97.116c-1.233 1.122.106 3.538.505 3.9s3.235 1.208 4.863-.359a3.032 3.032 0 00.7-1.011 5.626 5.626 0 00.384-2.229l.465.116a12.849 12.849 0 01-.081 2.34.4.4 0 00.682.293c.738-.723 1.855-2.305 2.234-5.485.581-4.883-4.312-5.217-5.414-5.106a6.551 6.551 0 01-2.527-.172c-2.755-1.587-2.5 1.244-2.108 2.31a9.389 9.389 0 00.506.986 9.692 9.692 0 01-.071 1.223.667.667 0 00.3.506s.278-.915.313-1.046.142-.506.192-.687a.192.192 0 01.111-.121 2.129 2.129 0 01.344-.1 11.877 11.877 0 011.446-.121.662.662 0 01.7.632c.066 1.517.849 1.8 1.208 1.85a.212.212 0 01.192.192c.238 1.86-.475 2.9-.783 2.952s-1.289-.773-1.289-.773-1.634-1.217-2.872-.09z"
            fill="#0b0b3a"
          />
          <path
            data-name="Path 9315"
            d="M172.269 96.181s.076-.834.718-.718a1.3 1.3 0 01-.035 2.34.4.4 0 01-.531-.374 5.746 5.746 0 00-.152-1.248z"
            fill="#f29d77"
          />
          <path
            data-name="Path 9316"
            d="M168.504 104.775s-3.033 9.877-2.411 14.609l1.112 2.022 1.213-2.2s-.986-9.458.9-14.26z"
            fill="#16405a"
          />
          <path
            data-name="Path 9317"
            d="M168.295 103.936v.131a2.625 2.625 0 00.192.708l.819.167.708-.505-.814-.95-.126.035a1.749 1.749 0 00-.783.425z"
            fill="#103649"
          />
          <path
            data-name="Path 9318"
            d="M172.724 101.671a9.607 9.607 0 01.6.829 6.76 6.76 0 00-1.036.505c-.425.258-2.467 1.7-2.467 1.7l-.6-1.238a20.721 20.721 0 013.503-1.796z"
            fill="#2496b5"
          />
          <path
            data-name="Path 9319"
            d="M169.216 103.465a1.718 1.718 0 00-.935.778 2.734 2.734 0 01-.056-1.638 1.6 1.6 0 01.849-.814z"
            fill="#2496b5"
          />
          <path
            data-name="Path 9320"
            d="M166.031 168.979a3.578 3.578 0 00-.248 1.2c.035.505 1.557.505 1.734.268a13.359 13.359 0 00.268-2.442"
            fill="#feaf84"
          />
          <path
            data-name="Path 9321"
            d="M167.921 170.861a9.9 9.9 0 01-.142 1.309h-1.754l-.086-.293a2.737 2.737 0 01-1.011.293h-1.481c-1.082 0-1.7-.137-1.724-.329-.116-.8 1.178-.758 1.517-.758a2.746 2.746 0 002.244-.945c.167-.359.091-.445.293-.379a.505.505 0 01.3.258.885.885 0 00.91.505 1.087 1.087 0 00.6-.288.642.642 0 01.334.627z"
            fill="#3a3a3a"
          />
          <path
            data-name="Path 9322"
            d="M183.086 167.325a14.553 14.553 0 00.531 1.714c.212.43 1.638-.1 1.709-.394a13.511 13.511 0 00-.657-2.366"
            fill="#feaf84"
          />
          <path
            data-name="Path 9323"
            d="M185.856 168.887c.187.465.46 1.36.46 1.36l-1.3.794-.263-.2a2.58 2.58 0 01-.7.728 5.733 5.733 0 01-1.314.546 3.294 3.294 0 01-2.25-.025c-.4-.7 1.208-1.082 1.516-1.2a2.164 2.164 0 001.34-1.769c0-.394-.081-.45.131-.465a.505.505 0 01.374.131.89.89 0 001.011.126 1.061 1.061 0 00.445-.505.637.637 0 01.55.479z"
            fill="#3a3a3a"
          />
          <path
            data-name="Path 9324"
            d="M176.925 133.138s2.386-5.7-1.769-9.847a22.894 22.894 0 01-6.384 1.779 14 14 0 01-3.372-.081 51.985 51.985 0 00-.607 10.995z"
            fill="#243a6c"
          />
          <path
            data-name="Path 9325"
            d="M167.994 169.529h-.212a12.219 12.219 0 01-2.32-.157v-.43c.081-6.526-.708-17.187-.859-20.574a3.752 3.752 0 010-.642c.253-2.472 2.806-2.148 3.877.121a8.737 8.737 0 01.607 1.744 15.54 15.54 0 01.394 2.467c.518 5.663-1.054 13.245-1.487 17.471z"
            fill="#243a6c"
          />
          <path
            data-name="Path 9326"
            d="M172.415 135.767a1.045 1.045 0 01-.04.212c-.566 2.972-2.4 11-3.271 13.613a1.577 1.577 0 01-1.122.824c-1.284.349-3.2-.131-3.362-2.689a6.358 6.358 0 010-.925c.106-1.335.2-7.037.177-10.828a15.254 15.254 0 01.541-3.847c.086-1.112.288-2.73.869-2.932 2.933-1.005 6.97 2.417 6.208 6.572z"
            fill="#243a6c"
          />
          <path
            data-name="Path 9327"
            d="M169.498 152.065c.505 5.636-1.072 13.259-1.517 17.465h-.212s.364-6.668.96-11.288a18.345 18.345 0 00-.758-7.825c-.121-.359-.2-.556-.2-.556l.718-2.022c.8-2.618.824-8.725.824-8.725a31.13 31.13 0 01-2.224-9.721l1.668.233 2.987 3.584.632 2.775c-.566 2.972-2.4 11-3.271 13.613a15.538 15.538 0 01.393 2.467z"
            fill="#1c3059"
          />
          <path
            data-name="Path 9328"
            d="M169.691 147.611a14.406 14.406 0 00-.192 4.469c.313 2.2-1.057-1.946-1.057-1.946l.728-1.517z"
            fill="#1c3059"
          />
          <path
            data-name="Path 9329"
            d="M178.233 147.686c-1.976-1.86-4.726-.981-3.442 1.906 1.375 3.073 5.621 11.667 7.926 17.763l.157.4a12.6 12.6 0 002.411-.784c-1.1-3.963-1.891-10.8-4.17-15.559a12.94 12.94 0 00-2.881-3.726z"
            fill="#243a6c"
          />
          <path
            data-name="Path 9330"
            d="M167.097 129.412c-.384-4.595 5.338-1.542 8.088-.03a3.914 3.914 0 011.734 3.119c.157 1.2 1.638 13.578 1.936 15.837.672 5.085-3.776 2.305-4.2.895-1.057-3.564-7.336-17.293-7.558-19.821z"
            fill="#243a6c"
          />
          <path
            data-name="Path 9331"
            d="M178.44 145.179a12.321 12.321 0 002.229 5.439s-3.351-1.542-3.513-1.769a12.567 12.567 0 01-.682-2.841c.081-.248 1.966-.829 1.966-.829z"
            fill="#243a6c"
          />
          <path
            data-name="Path 9332"
            d="M172.88 125.106l.258.227s2.022-1.759 3.6-3.245a17.93 17.93 0 003.872-4.782 2.529 2.529 0 00.126-.263.614.614 0 00.04-.162.5.5 0 000-.091.549.549 0 000-.1v-.273a1.226 1.226 0 000-.136 8.96 8.96 0 00-.111-1.329c-.167-1.825-1.971-7.542-2.588-9.928a1.612 1.612 0 00-.561-.88 1.441 1.441 0 00-.854-.339h-.147a15.582 15.582 0 011.517 4.327c.8 3.306 1.37 5.308 1.6 6.571a4.4 4.4 0 01.1 1.38 4.17 4.17 0 01-.576 1.2c-1.302 2.313-4.83 6.832-6.276 7.823z"
            fill="#2496b5"
          />
          <path
            data-name="Path 9333"
            d="M139.391 93.481a7.456 7.456 0 002.644-2.745 4.68 4.68 0 000-.819 3.429 3.429 0 00-2.29-3.26c-2.674-.814-4.266 1.056-6.248-1.982v.051c.642 2.897.531 9.069 5.894 8.755z"
            fill="#fff"
          />
          <path
            data-name="Path 9334"
            d="M139.391 93.477a7.456 7.456 0 002.644-2.745 4.677 4.677 0 000-.819c-5.722 6.026-8.341-4.4-8.528-5.191.632 2.902.521 9.074 5.884 8.755z"
            fill="#ffe7c5"
          />
          <g data-name="Group 471">
            <path
              data-name="Path 9335"
              d="M133.512 84.722a5.626 5.626 0 001.83 2.174 4.221 4.221 0 001.259.637 6.367 6.367 0 001.405.207 5.929 5.929 0 011.461.227 2.886 2.886 0 011.249.834 2.786 2.786 0 01.622 1.35 3.085 3.085 0 01-.147 1.456 2.917 2.917 0 00-.662-2.634 2.73 2.73 0 00-1.152-.733 8.263 8.263 0 00-1.4-.207 6.652 6.652 0 01-1.456-.248 4.407 4.407 0 01-1.294-.728 5.186 5.186 0 01-1.714-2.335z"
              fill="#ffe7c5"
            />
          </g>
          <g data-name="Group 472">
            <path
              data-name="Path 9336"
              d="M133.512 84.722a9.1 9.1 0 001.2 2.406 6.3 6.3 0 001.931 1.8 10.006 10.006 0 001.228.536 6.278 6.278 0 011.218.652 3.262 3.262 0 01.95 1.011 2.74 2.74 0 01.334 1.324 2.912 2.912 0 00-1.425-2.133 6.176 6.176 0 00-1.183-.6 6.749 6.749 0 01-1.264-.551 5.874 5.874 0 01-1.961-1.931 7.362 7.362 0 01-1.028-2.514z"
              fill="#ffe7c5"
            />
          </g>
          <path
            data-name="Path 9337"
            d="M180.868 134.563a1.3 1.3 0 01-.414-.066c-1.587-.505-2.189-4-2.255-4.4l-.071-.45.44.116c.389.1 3.827 1.041 4.236 2.613a1.517 1.517 0 01-.546 1.481 2.057 2.057 0 01-1.39.706zm-1.992-4.09c.243 1.163.849 3.159 1.764 3.458.349.111.753-.056 1.2-.505a.94.94 0 00.389-.91c-.249-.895-2.205-1.683-3.353-2.042z"
            fill="#0b0b3a"
          />
          <path
            data-name="Rectangle 1264"
            fill="#ffc25b"
            d="M140.244 94.35l2.706-2.683 37.075 37.39-2.706 2.684z"
          />
          <path
            data-name="Rectangle 1265"
            fill="#ffa92c"
            d="M139.304 93.408l2.706-2.683.935.944-2.705 2.683z"
          />
          <path
            data-name="Rectangle 1266"
            fill="#ff8736"
            d="M140.244 94.35l2.706-2.683 37.075 37.39-2.706 2.684z"
          />
          <path
            data-name="Rectangle 1267"
            fill="#0b0b3a"
            d="M139.304 93.408l2.706-2.683.935.944-2.705 2.683z"
          />
          <path
            data-name="Path 9338"
            d="M180.013 129.067l-1.026 1.016-37.062-37.405-.935-.94-1.688 1.663 2.709-2.684.935.94z"
            fill="#ffc25b"
          />
          <path
            data-name="Rectangle 1268"
            fill="#0b0b3a"
            d="M176.787 131.233l2.706-2.683.523.528-2.706 2.683z"
          />
          <path
            data-name="Path 9339"
            d="M173.825 124.777l-1.6-1.329s-.47.778-.814.885a2.483 2.483 0 01-.425-.045 2.78 2.78 0 00-1.289.4c-.374.172-.869.329-.89.475s.243.389.505.369a.506.506 0 00.126 0 .83.83 0 00.03.157c.111.339 1.678 2.527 3.235.147a4.375 4.375 0 011.122-1.059z"
            fill="#ffbc9f"
          />
          <path
            data-name="Path 9340"
            d="M174.629 109.194a45.878 45.878 0 002.153 6.359c0 .051.046.1.066.136v.025a1.819 1.819 0 00.076.243 1.946 1.946 0 001.9 1.3h1.193a.914.914 0 00.713-.248.617.617 0 00.04-.162.5.5 0 000-.091.549.549 0 000-.1v-.273a1.241 1.241 0 000-.136 8.969 8.969 0 00-.111-1.329c-.167-1.825-1.971-7.542-2.588-9.928a1.612 1.612 0 00-.561-.88 1.441 1.441 0 00-.854-.339h-.154a2.071 2.071 0 00-1.719 1.405 4.887 4.887 0 00-.475 1.582 5.672 5.672 0 00.321 2.436z"
            fill="#35aad3"
          />
          <path
            data-name="Path 9341"
            d="M171.809 124.019l1.077 1.087.258.227s2.022-1.759 3.6-3.245a17.93 17.93 0 003.872-4.782 2.533 2.533 0 00.126-.263.618.618 0 00.04-.162.509.509 0 000-.091.555.555 0 000-.1v-.273a1.227 1.227 0 000-.136 1.658 1.658 0 00-.369-1.067l-.076-.086a1.728 1.728 0 00-.394-.288 2.106 2.106 0 00-.3-.126 2.811 2.811 0 00-2.26.308l-.192.2a5.725 5.725 0 00-.42.506 8.217 8.217 0 00-1.087 1.82 48.839 48.839 0 01-3.875 6.471z"
            fill="#35aad3"
          />
          <path
            data-name="Path 9342"
            d="M148.111 102.278s-2.431-1.693-2.527-2.988c-.121-1.431.885-2.118 1.517-1.329a5.292 5.292 0 01.763 3.483l.232.834z"
            fill="#ffd4c5"
          />
          <path
            data-name="Rectangle 1269"
            fill="#ffdc8f"
            d="M196.699 83.736h6v6.976h-6z"
          />
          <path
            data-name="Path 9343"
            d="M200.127 84.453a.42.42 0 11-.415-.415.42.42 0 01.415.415z"
            fill="#ff8736"
          />
          <path
            data-name="Rectangle 1270"
            fill="#ffdc8f"
            d="M205.359 81.385h6v6.976h-6z"
          />
          <path
            data-name="Path 9344"
            d="M208.771 82.104a.42.42 0 11-.42-.42.42.42 0 01.42.42z"
            fill="#ff8736"
          />
          <path
            data-name="Path 9345"
            d="M134.038 82.725s-2.361-3.837-.505-4.17.835 3.604.505 4.17z"
            fill="#fff"
          />
          <path
            data-name="Path 9346"
            d="M134.614 82.725s.809-2.674 1.9-1.547-1.9 1.547-1.9 1.547z"
            fill="#fff"
          />
          <path
            data-name="Path 9347"
            d="M200.127 43.584s-.505 19.042 15.509 20.811c3.114.3 8.826.157 8.427-4.388a7.712 7.712 0 00-4.464-6.015c-1.966-.728-4.044-1.193-5.965-2.022a4.964 4.964 0 01-2.472-1.921c-1.011-1.734-.556-4.044-1.289-5.894a10.317 10.317 0 00-3.645-4.651c-2.351-1.658-5.3-1.668-5.97 1.607a13.876 13.876 0 00-.131 2.473z"
            fill="#c3ecfe"
            opacity={0.35}
          />
          <path
            data-name="Path 9348"
            d="M70.492 26.362c-.415.339-.874.632-1.319.935-4.792 3.266-9.064 8.695-9.3 14.695-.3 7.684-11.768.329-8.715-10.641s12.767-10.974 15.416-10.623c1.567.207 4.549.935 5.141 2.669a2.472 2.472 0 01-.581 2.33 4.7 4.7 0 01-.642.635z"
            fill="#c3ecfe"
            opacity={0.35}
          />
        </g>
      </g>
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
